<div class="flexable flex gap-2 p-2 rounded-xl">
  <div class="flex gap-1 items-center rounded-tab w-fit p-2">
    <span class="text-black">Warehouse: </span>
    <div>
      <select
        [(ngModel)]="filtering.warehouse"
        (ngModelChange)="onFilterChange($event, 'warehouse')"
      >
        <option [ngValue]="null">Choose Warehouse</option>
        <option
          *ngFor="let warehouse of warehouses$ | async"
          [ngValue]="warehouse?.uniqueId"
        >
          {{ warehouse?.name }}
        </option>
      </select>
    </div>
  </div>
    <div
    class="flex gap-2 items-center rounded-tab w-fit p-2"
    *ngIf="filtering.warehouse && (warehouseSensors$ | async)?.length"
  >
    <span class="text-black">Sensor:</span>
    <select
      [(ngModel)]="filtering.sensor"
      (ngModelChange)="onFilterChange($event, 'sensor')"
    >
      <option value="">Select sensor</option>
      <option
        *ngFor="let sensor of warehouseSensors$ | async; let i = index"
        [value]="sensor.uniqueId"
        [selected]="i === 0"
      >
        {{ sensor.sensorName }}
      </option>
    </select>
  </div>

  <div class="flex gap-4 items-center rounded-tab w-fit p-2">
    <span class="text-black">Timeframe: </span>
    <div class="flex items-center gap-1">
      @for (tab of timeframeTabs; track tab) {
        @if (tab?.name === activeTimeframeTab) {
          <span
            class="!bg-[#3A7AA8] !text-white !px-[12px] rounded-full !py-[8px]"
          >
            <span class="text-white text-[13px] relative">{{ tab?.name }}</span>
          </span>
        } @else {
          <span
            (click)="
              activeTimeframeTab = tab?.name;
              onFilterChange(tab?.name, 'timeframe')
            "
            class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8]"
            >{{ tab?.name }}</span
          >
        }
      }
      @if (activeTimeframeTab) {
        <div
          (click)="
            activeTimeframeTab = null;
            filtering.dateTo = null;
            filtering.dateFrom = null
          "
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8] !w-fit flex !min-w-[132px] gap-1"
        >
          <fa-icon [icon]="faCalendar"></fa-icon>
          <span>Custom Date</span>
        </div>
      } @else {
        <span
          class="!cursor-pointer !bg-[#3A7AA8] !px-[12px] rounded-full !py-[8px] !min-w-[132px] gap-1"
        >
          <span class="text-white !text-[13px]">
            <fa-icon [icon]="faCalendar"></fa-icon>
            Custom Date
          </span>
        </span>
      }

      <div
        class="flex gap-1"
        [ngStyle]="{ display: activeTimeframeTab ? 'none' : '' }"
      >
        <div class="custom-date-input-container">
          <input
            type="text"
            class="custom-date-input"
            [max]="endDate"
            [(ngModel)]="startDate"
            (dateChange)="onFilterChange(null, 'dateFrom')"
            [disabled]="activeTimeframeTab"
            [matDatepicker]="startDatePicker"
            placeholder="Select Start Date"
            readonly
            (click)="startDatePicker.open()"
          />
          <button
            class="calendar-button"
            mat-icon-button
            [disabled]="activeTimeframeTab"
            (click)="startDatePicker.open()"
          >
            <img src="assets/icons/calendar-02.png" alt="" srcset="" />
          </button>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </div>

        <div class="custom-date-input-container">
          <input
            type="text"
            class="custom-date-input"
            [(ngModel)]="endDate"
            [min]="startDate"
            (dateChange)="onFilterChange(null, 'dateTo')"
            [disabled]="activeTimeframeTab"
            [matDatepicker]="endDatePicker"
            placeholder="Select End Date"
            readonly
            (click)="endDatePicker.open()"
          />
          <button
            class="calendar-button"
            mat-icon-button
            [disabled]="activeTimeframeTab"
            (click)="endDatePicker.open()"
          >
            <img src="assets/icons/calendar-02.png" alt="" srcset="" />
          </button>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </div>
      </div>
    </div>
  </div>
  <div class="flex gap-4 items-center rounded-tab w-fit p-2" *ngIf="filtering.sensor">
  <span class="text-black">Frequency: </span>
  <div class="flex gap-2">
    <ng-container *ngFor="let tab of frequencyTabs">
      <span
        *ngIf="tab.name === activeFrequencyTab; else inactiveFreqTab"
        class="!bg-[#3A7AA8] !text-white !px-[12px] rounded-full !py-[8px]"
      >
        {{ tab.name }}
      </span>

      <ng-template #inactiveFreqTab>
        <span
          (click)="
            activeFrequencyTab = tab.name;
            onFilterChange(tab.name, 'timerange')
          "
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8]"
        >
          {{ tab.name }}
        </span>
      </ng-template>
    </ng-container>
  </div>
</div>

  <div class="flex justify-end">
    <button
      (click)="generateReport()"
      class="rounded-full py-[8px] px-[12px] flex gap-2 text-[13px] font-normal bg-[#dbdbdb] text-[#9b9b9b]"
      [ngClass]="{
        '!bg-[#025590] !text-white':
          filtering.warehouse && filtering.warehouse !== 'null',
        ' cursor-not-allowed':
          !filtering.warehouse && filtering.warehouse === 'null',
      }"
      [disabled]="!filtering.warehouse || filtering.warehouse === 'null'"
    >
      Generate
    </button>
  </div>
</div>

<div class="mt-8">
  <div class="flex flex-col gap-3 bg-primary-50 p-4 rounded-xl">
    <div class="flex justify-between items-center px-8 border-t pt-6 mt-4">
      <img src="/assets/images/emblem.png" class="w-24" />

      <div class="flex flex-col gap-1 items-center">
        <span class="font-bold text-2xl text-[#005590]"
          >The United Republic of Tanzania</span
        >
        <span class="font-bold text-xl text-[#005590]"
          >Medical Stores Department</span
        >
        <span class="font-bold text-[#005590]"
          >Environmental Warehouse Report</span
        >
      </div>

      <img src="/assets/images/logo.svg" class="h-full" />
    </div>

    <div *ngIf="noDataMessage" class="flex flex-col items-center justify-center py-20 gap-4">
      <div class="flex items-center justify-center w-24 h-24 rounded-full bg-blue-50">
        <mat-icon class="!text-5xl !w-12 !h-12 text-[#025590]">search_off</mat-icon>
      </div>
      <p class="text-base font-semibold text-gray-500 text-center max-w-sm">{{ noDataMessage }}</p>
    </div>

    @if (showChart) {
      <div class="grid grid-cols-12 gap-4 mt-12">
        <div class="col-span-12">
          <div class="bg-primary-50 rounded-lg p-2 flex flex-col gap-2">
            <div class="flex gap-2">
              <span class="font-bold">Warehouse Name:</span>
              <span>{{ highestTemperatureSummary.warehouse_name }}</span>
            </div>
          </div>
        </div>

        <div class="col-span-12 md:col-span-8 w-full">
          <app-bar-graph
            *ngIf="showChart"
            title="Average Temperature"
            [data]="temperatureData"
            [width]="'100%'"
            [height]="350"
            [gridX]="true"
            [horizontal]="true"
            [gridY]="true"
            [xAxis]="temperatureLabels"
            [showXlabel]="true"
            [showYlabel]="true"
            columnWidth="25%"
            chart_type="line"
            LegendPosition="top"
            horizontalAlign="right"
          ></app-bar-graph>
        </div>

        <div class="col-span-12 md:col-span-4 flex flex-col gap-8">
          <div class="">
            <div class="font-bold mt-4">Temperature Summary</div>

            <div
              class="bg-red-50 rounded-t-lg text-red-600 p-2 mt-4 flex flex-col gap-2"
            >
              <span>Highest Temperature</span>
              <div class="flex gap-2">
                <div class="flex items-center font-bold text-5xl">
                  {{ highestTemperatureSummary?.temperature }}&deg;C
                </div>
                <mat-divider [vertical]="true"></mat-divider>
                <div class="flex flex-col gap-0.5">
                  <div class="flex gap-2">
                    <span class="font-bold"> Zone:</span>
                    <span>{{ highestTemperatureSummary.zone_name }}</span>
                  </div>
                  <div class="flex gap-2">
                    <span class="font-bold">Sensor:</span>
                    <span>{{ highestTemperatureSummary.sensor_id }}</span>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div
                  class="flex gap-2 text-xs py-1 px-1.5 rounded-full border border-red-100 bg-white/70"
                >
                  <span class="font-bold">Recorded On:</span>
                  <span>{{ highestTemperatureSummary.reading_date }}</span>
                </div>
              </div>
            </div>
            <mat-divider></mat-divider>
            <div
              class="bg-blue-50 rounded-b-lg text-blue-600 p-2 flex flex-col gap-2"
            >
              <span>Lowest Temperature</span>
              <div class="flex gap-2">
                <div class="flex items-center font-bold text-5xl">
                  {{ lowestTemperatureSummary.temperature }}&deg;C
                </div>
                <mat-divider [vertical]="true"></mat-divider>
                <div class="flex flex-col gap-0.5">
                  <div class="flex gap-2">
                    <span class="font-bold">Zone:</span>
                    <span>{{ lowestTemperatureSummary.zone_name }}</span>
                  </div>
                  <div class="flex gap-2">
                    <span class="font-bold">Sensor:</span>
                    <span>{{ lowestTemperatureSummary.sensor_id }}</span>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div
                  class="flex gap-2 text-xs py-1 px-1.5 rounded-full border border-blue-100 bg-white/70"
                >
                  <span class="font-bold">Recorded On:</span>
                  <span>{{ lowestTemperatureSummary.reading_date }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-span-12 grid grid-cols-12 mt-3">
          <div class="col-span-12 md:col-span-8 w-full">
            <app-bar-graph
              *ngIf="showChart"
              title="Average Humidity"
              [data]="humidityData"
              [width]="'100%'"
              [height]="350"
              [gridX]="true"
              [horizontal]="true"
              [gridY]="true"
              [xAxis]="temperatureLabels"
              [showXlabel]="true"
              [showYlabel]="true"
              columnWidth="25%"
              chart_type="line"
              LegendPosition="top"
              horizontalAlign="right"
            ></app-bar-graph>
          </div>
          <div class="col-span-12 md:col-span-4 flex flex-col gap-8">
            <div class="">
              <div class="font-bold mt-4">Humidity Summary</div>

              <div
                class="bg-blue-50 rounded-t-lg text-blue-600 p-2 mt-4 flex flex-col gap-2"
              >
                <span>Highest Humidity</span>
                <div class="flex gap-2">
                  <div class="flex items-center font-bold text-5xl">
                    {{ highestHumiditySummary.humidity }}%
                  </div>
                  <mat-divider [vertical]="true"></mat-divider>
                  <div class="flex flex-col gap-0.5">
                    <div class="flex gap-2">
                      <span class="font-bold">Zone:</span>
                      <span>{{ highestHumiditySummary.zone_name }}</span>
                    </div>
                    <div class="flex gap-2">
                      <span class="font-bold">Sensor:</span>
                      <span>{{ highestHumiditySummary.sensor_id }}</span>
                    </div>
                  </div>
                </div>
                <div class="flex">
                  <div
                    class="flex gap-2 text-xs py-1 px-1.5 rounded-full border border-blue-100 bg-white/70"
                  >
                    <span class="font-bold">Recorded On:</span>
                    <span>{{ highestHumiditySummary.reading_date }}</span>
                  </div>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div
                class="bg-[#A5D0F0]/10 rounded-b-lg text-[#4dc3ff] p-2 flex flex-col gap-2"
              >
                <span>Lowest Humidity</span>
                <div class="flex gap-2">
                  <div class="flex items-center font-bold text-5xl">
                    {{ lowestHumiditySummary.humidity }}%
                  </div>
                  <mat-divider [vertical]="true"></mat-divider>
                  <div class="flex flex-col gap-0.5">
                    <div class="flex gap-2">
                      <span class="font-bold">Zone:</span>
                      <span>{{ lowestHumiditySummary.zone_name }}</span>
                    </div>
                    <div class="flex gap-2">
                      <span class="font-bold">Sensor:</span>
                      <span>{{ lowestHumiditySummary.sensor_id }}</span>
                    </div>
                  </div>
                </div>
                <div class="flex">
                  <div
                    class="flex gap-2 text-xs py-1 px-1.5 rounded-full border border-[#4dc3ff] bg-white/70"
                  >
                    <span class="font-bold">Recorded On:</span>
                    <span>{{ lowestHumiditySummary.reading_date }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
